import * as FutureFragment from "@eyeo-fragments/in-product-messaging/background";
import * as LegacyFragment from "@eyeo-fragments/ipm-legacy/background";
import * as ewe from "@eyeo/webext-ad-filtering-solution";
import { port } from "../../../adblockplusui/adblockpluschrome/lib/messaging/port";
import { getFutureFragmentOverrides, getLegacyFragmentOverrides } from "./fragment-overrides";
import { featureFlagId, FragmentType, } from "./fragment-provider.types";
import { getFutureStartInfo, legacyStartInfo } from "./start-info";
let selectedFragmentType = FragmentType.legacy;
async function getExpectedFragmentType() {
    const featureFlag = await ewe.experiments.getFlag(featureFlagId);
    return featureFlag === true ? FragmentType.future : FragmentType.legacy;
}
export function getFragment() {
    if (selectedFragmentType === FragmentType.legacy) {
        return { ...LegacyFragment, ...getLegacyFragmentOverrides() };
    }
    return { ...FutureFragment, ...getFutureFragmentOverrides() };
}
async function selectFragment() {
    selectedFragmentType = await getExpectedFragmentType();
}
async function switchFragment() {
    const expectedFragmentType = await getExpectedFragmentType();
    if (expectedFragmentType === selectedFragmentType) {
        return;
    }
    await getFragment().stop();
    await selectFragment();
    await startFragment();
}
async function startFragment() {
    const fragment = getFragment();
    if (selectedFragmentType === FragmentType.legacy) {
        await fragment.start(legacyStartInfo);
        return;
    }
    const futureStartInfo = await getFutureStartInfo();
    await fragment.start(futureStartInfo);
}
export async function start() {
    await selectFragment();
    await startFragment();
    ewe.experiments.onChanged.addListener(() => {
        void switchFragment();
    });
    port.on("testing.getSelectedFragmentType", () => {
        return selectedFragmentType;
    });
    port.on("testing.resetIPMFragment", async () => {
        await ewe.experiments.clearFlagOverrides();
    });
    port.on("testing.setIPMFragment", async (message) => {
        await ewe.experiments.overrideFlag(featureFlagId, message.fragmentType === FragmentType.future);
    });
}
